var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "corp-id" }, [
    _vm._v("\n    " + _vm._s(_vm.$l10n.__("ID Compte Sellsy")) + " - "),
    _c("span", [_vm._v(_vm._s(_vm.corpId))])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }